import React from "react";
import { useTranslation } from "react-i18next";
import { BellOff, Loader2 } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import NotificationCard from "./NotificationCard";

const NotificationsList = ({
  loading, notifications, filter,
  selectedNotifications, handleToggleSelection, handleMarkAsRead, handleDeleteNotification,
}) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <Card>
        <CardContent className="py-12">
          <div className="text-center">
            <Loader2 className="h-8 w-8 animate-spin mx-auto text-muted-foreground" />
            <p className="mt-2 text-sm text-muted-foreground">{t("planning.legacy.notifications.loading")}</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  if (notifications.length === 0) {
    return (
      <Card>
        <CardContent className="py-12 text-center text-muted-foreground">
          <BellOff className="h-12 w-12 mx-auto mb-2 text-muted-foreground" />
          <p>{t("planning.legacy.notifications.emptyTitle")}</p>
          <p className="text-sm mt-1">
            {filter === "unread" ? t("planning.legacy.notifications.emptyUnread") : t("planning.legacy.notifications.emptyAll")}
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-2">
      {notifications.map((notification) => (
        <NotificationCard
          key={notification.id}
          notification={notification}
          selectedNotifications={selectedNotifications}
          handleToggleSelection={handleToggleSelection}
          handleMarkAsRead={handleMarkAsRead}
          handleDeleteNotification={handleDeleteNotification}
        />
      ))}
    </div>
  );
};

export default NotificationsList;
